/**
 * Labstep
 */

import { OrganizationEmptyStateNoSeatsLeft } from 'labstep-web/components/Organization/EmptyState/NoSeatsLeft';
import { OrganizationHeader } from 'labstep-web/components/Organization/Header';
import { ShareLinkAcceptEntityGroupOrOrganizationContent } from 'labstep-web/components/ShareLink/Accept/Entity/GroupOrOrganization/Content';
import { ShareLinkRedirect } from 'labstep-web/components/ShareLink/Redirect';
import { LimitTypes } from 'labstep-web/constants/limits';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { Header } from 'labstep-web/core/Header';
import { useHasExceededLimit } from 'labstep-web/hooks/limits/limits';
import { Group } from 'labstep-web/models/group.model';
import { Organization } from 'labstep-web/models/organization.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import { ShareLinkAcceptEntityGroupOrOrganizationLimitReached } from './LimitReached';
import type { IShareLinkAcceptEntityGroupOrOrganizationProps } from './types';

export const ShareLinkAcceptEntityGroupOrOrganization: React.FC<
  IShareLinkAcceptEntityGroupOrOrganizationProps
> = ({ shareLink, onClick, status, authenticatedUserEntity }) => {
  const isGroup = shareLink.entity instanceof Group;
  const groupOrganization = isGroup
    ? shareLink.entity.organization
    : null;

  let showUserLimitWarning = useHasExceededLimit(
    isGroup ? shareLink.entity.user_count : -1,
    LimitTypes.MAX_USERS_PER_GROUP,
  );

  if (groupOrganization) {
    showUserLimitWarning = false;
  }

  const showGroupLimitWarning = useHasExceededLimit(
    authenticatedUserEntity?.group_count,
    LimitTypes.MAX_GROUPS_PER_USER,
  );

  const entityDisplayName = getHumanReadableEntityName(
    shareLink.entity.entityName,
  );

  const renderContent = () => {
    switch (true) {
      case shareLink.group &&
        shareLink.group.logged_user_user_group !== null:
        return <ShareLinkRedirect shareLink={shareLink} />;

      case showGroupLimitWarning:
        return (
          <ShareLinkAcceptEntityGroupOrOrganizationLimitReached
            heading={`
          You have reached your ${entityDisplayName} limit`}
            description={`
          You have already joined the maximum number of ${entityDisplayName} that an
          Academic user can join.`}
            onClick={onClick}
            showUpgrade
          />
        );

      case showUserLimitWarning:
        return (
          <ShareLinkAcceptEntityGroupOrOrganizationLimitReached
            heading={`Invited ${entityDisplayName} full`}
            description={`
          The ${entityDisplayName} you were
          invited to has reached its user limit, so you cannot join.`}
            onClick={onClick}
          />
        );

      case shareLink.organization?.noSeatsLeft:
        return (
          <OrganizationEmptyStateNoSeatsLeft
            organization={shareLink.organization}
          />
        );

      default:
        return (
          <>
            {shareLink.organization && (
              <OrganizationHeader
                organization={shareLink.organization}
              />
            )}
            <Header size="small">
              {`You have been invited to join the ${
                shareLink.entity.displayName
              } ${getHumanReadableEntityName(
                shareLink.entity.entityName,
              )} on Labstep.`}
            </Header>
            <ShareLinkAcceptEntityGroupOrOrganizationContent
              shareLink={shareLink}
              onClick={onClick}
              status={status}
            />
          </>
        );
    }
  };

  return (
    <div
      style={{
        textAlign: 'center',
        margin: 'auto',
        marginTop: '10%',
      }}
    >
      {renderContent()}
    </div>
  );
};

export default withAuthenticatedUserEntity(
  ShareLinkAcceptEntityGroupOrOrganization,
);
